// client/extensions/BulletList.ts
import TiptapBulletList from "@tiptap/extension-bullet-list";
var BulletList = {
  extensions: [
    TiptapBulletList.extend({
      addAttributes() {
        return {
          color: {
            renderHTML: (attributes) => {
              return {
                style: `margin: 0; padding-inline-start: 2em;`
              };
            }
          }
        };
      }
    })
  ]
};
export {
  BulletList
};
